import { Language } from "../data/constants";

const languageMap: Record<string, Language> = {
    "StdZR1": Language.DE,
    "CbQN1C": Language.EN,
    "gbyNFc": Language.FR,
    "j1JhHy": Language.IT,
  };

export const getLanguageFromKey = (key: string): Language => {
  return languageMap[key];
}

export const getKeyFromLanguage = (language: Language): string => {
  const entry = Object.entries(languageMap).find(([_, value]) => value === language);
  return entry ? entry[0] : "";
}

export const ExamLanguages = [Language.DE, Language.FR, Language.IT];